import React, { PropsWithChildren } from 'react';

import { Grid } from '@zapier/design-system';

type Props = PropsWithChildren<{}>;

/**
 * Display a list of tags along a 1-D grid. Children that are falsey are filterd out
 * so we don’t add empty gap spacing when those elements are empty.
 */
export default function TagGroup({ children }: Props) {
  const numTags = React.Children.toArray(children).filter(Boolean).length;

  return (
    <Grid columns={`repeat(${numTags}, auto)`} gap={7}>
      {children}
    </Grid>
  );
}
